var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCloudSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.54 56.06L15.88 34.55C14.94 34.12 13.38 33.29 10.88 34.55C9.45001 35.27 10.3 36.75 10.88 37.06L50.41 60.14C51.24 60.56 53.29 61.02 54.79 59.51C56.29 58 54.58 56.58 53.54 56.06Z",
    fill: "url(#paint0_linear_1353_380383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.63 43.7999C54.63 40.5399 52.34 36.5899 49.52 34.9699C48.99 34.6599 48.4 34.4399 47.77 34.3199C47.09 30.6899 44.82 26.8499 41.98 24.5299C41.96 24.5099 41.94 24.4899 41.92 24.4699C41.83 24.3999 41.74 24.3199 41.64 24.2499L41.53 24.1799L41.27 23.9999L41.16 23.9299L40.9 23.7599L40.79 23.6899C40.66 23.6199 40.55 23.5399 40.42 23.4699C40.29 23.3999 40.18 23.3199 40.05 23.2699L40.01 23.2499C39.9 23.1899 39.79 23.1399 39.68 23.0799L39.61 23.0399C38.93 22.7099 38.19 22.5199 37.42 22.4499C37 17.8599 34.12 12.7099 30.43 9.85992C30.32 9.76992 30.19 9.67992 30.08 9.59992C29.97 9.52992 29.84 9.42992 29.73 9.35992L29.64 9.29992C29.55 9.23992 29.46 9.16992 29.36 9.11992C29.23 9.04992 29.1 8.94992 28.97 8.87992C28.84 8.80992 28.71 8.72992 28.6 8.67992L28.49 8.61992C28.42 8.57992 28.34 8.54992 28.25 8.50992L28.16 8.44992L28.07 8.40992C28 8.36992 27.94 8.34992 27.87 8.31992L27.76 8.25992C27.7 8.23992 27.65 8.21992 27.59 8.19992L27.52 8.15992L27.35 8.08992L27.17 8.02992L26.97 7.96992L26.79 7.92992C26.72 7.90992 26.66 7.88992 26.59 7.86992L26.41 7.82992L26.21 7.76992L26.04 7.72992L25.86 7.70992C25.8 7.70992 25.75 7.68992 25.69 7.68992L25.51 7.66992H24.98C24.92 7.66992 24.85 7.66992 24.8 7.68992L24.65 7.70992C24.59 7.70992 24.52 7.72992 24.47 7.72992L24.32 7.74992C24.26 7.76992 24.19 7.76992 24.14 7.78992L24.01 7.82992C23.95 7.84992 23.88 7.86992 23.83 7.88992C23.77 7.90992 23.76 7.90992 23.7 7.92992C23.63 7.94992 23.57 7.98992 23.5 7.99992C23.46 8.01992 23.43 8.01992 23.41 8.03992C23.32 8.07992 23.23 8.12992 23.13 8.16992L23.06 8.20992L22.95 8.27992L18.19 11.0999L19.78 12.3499C19.71 12.3899 19.63 12.4199 19.54 12.4599H19.52L11.46 17.0899L14.59 18.5299L17.49 17.6399C17.8 21.8099 20.72 26.6199 24.26 28.6699L47.44 45.2099L48.16 50.0199L53.18 47.0699H53.2L53.24 47.0499C54.11 46.4999 54.68 45.3699 54.68 43.7699L54.63 43.7999Z",
    fill: "url(#paint1_linear_1353_380383)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.52 37.9001C43.99 37.5901 43.4 37.3701 42.77 37.2501C41.96 32.9701 38.99 28.4401 35.45 26.3901C34.38 25.7801 33.37 25.4501 32.44 25.3801C31.96 20.2001 28.36 14.3201 23.99 11.7901C19.29 9.0801 15.47 11.2701 15.47 16.7101C15.47 16.8901 15.47 17.0801 15.49 17.2601C12.06 15.6701 9.37 17.4601 9.37 21.5401C9.37 25.8701 12.41 31.1501 16.17 33.3101L44.53 49.6901C47.35 51.3101 49.64 50.0001 49.64 46.7401C49.64 43.4801 47.33 39.5301 44.51 37.9101L44.52 37.9001Z",
    fill: "url(#paint2_linear_1353_380383)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1353_380383",
    x1: 54.88,
    y1: 59.98,
    x2: 11.46,
    y2: 34.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1353_380383",
    x1: 16.39,
    y1: 7.93992,
    x2: 50.79,
    y2: 48.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1353_380383",
    x1: 9.37,
    y1: 30.5001,
    x2: 49.65,
    y2: 30.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCloudSmall);
export default __webpack_public_path__ + "static/media/no_cloud_small.f4b0ef22d1b60037674a9548034907d0.svg";
export { ForwardRef as ReactComponent };